export default "__VITE_ASSET__VCLUkndW__"